import React from 'react';
import { ArrayHelpers, Paging, SystemText } from 'e4shared';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGet } from 'services';
import BlobImage from 'components/blobImage';
import WidgetBase from 'views/myDashboard/components/widgets/_base';
import { isPast } from 'helpers/dates';

export const Leaderboard = ({ item }) => {
    const loaded = React.useRef(null);
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [pagedData, setPagedData] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(6);
    const recordCount = data.length;

    const user = useSelector(state => state.user.user);

    const loadLeaderBoard = () => {
        setLoading(true);
        apiGet(`dashboard/full-leaderboard?range=${item.range}`, user.guid, response => {
            setData(response);
            setLoading(false);
        });
    };

    React.useEffect(() => {
        loadLeaderBoard();
    }, [item.range]);

    React.useEffect(() => {
        setPagedData(ArrayHelpers.getPage(data, page, pageSize));
    }, [page]);

    React.useEffect(() => {
        const pageSizeGenerator = () => {
            const rowHeight = 40;
            const extrasHeight = 90;
            const thisHeight = 105 * item.h - 70;
            let result = Math.ceil((thisHeight - extrasHeight) / rowHeight);
            if (result < recordCount) result--;
            return result < 1 ? 1 : result;
        };

        const ps = pageSizeGenerator();
        setPagedData(ArrayHelpers.getPage(data, 1, ps));
        setPage(1);
        setPageSize(ps);
    }, [loaded.current, data, item.h, recordCount]);

    const text = {
        staff: SystemText('Home/Widgets/Leaderboard/Staff'),
        score: SystemText('Home/Widgets/Leaderboard/Score'),
    };

    const chart = (
        <div ref={loaded}>
            <table className="table table-condensed">
                <tbody>
                    <tr>
                        <th width="1">#</th>
                        <th>{text.staff}</th>
                        <th width="1" className="text-right">
                            {text.score}
                        </th>
                    </tr>
                    {pagedData.map((t, i) => {
                        let extra = 'fa-face-smile text-info';
                        if (t.awaiting) extra = 'fa-face-meh text-warning';
                        if (t.overdue > 0 || (t.nextReview && isPast(t.nextReview))) extra = 'fa-face-frown text-danger';

                        return (
                            <tr key={t.id} className={t.id === user.id ? 'bold' : ''}>
                                <td className="no-wrap" style={null}>
                                    {(page - 1) * pageSize + i + 1}.
                                </td>
                                <td className="no-wrap">
                                    <Link to={`/search/${t.full_Name}`} className="flex flex-center">
                                        <BlobImage
                                            height="30"
                                            className="img-circle mr10"
                                            folder="avatar"
                                            key={t.avatar}
                                            src={t.avatar}
                                            alt={t.full_Name}
                                        />
                                        <div style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {t.full_Name}
                                        </div>
                                    </Link>
                                </td>
                                <td style={null} className="no-wrap text-right">
                                    <span>{t.e4Score}</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {recordCount > pageSize && (
                <div className="text-center mt10">
                    <Paging
                        page={page}
                        narrow={item.w < 3}
                        pageSize={pageSize}
                        recordCount={recordCount}
                        goToPage={setPage}
                    />
                </div>
            )}
        </div>
    );

    return (
        <WidgetBase
            filters={null}
            chart={chart}
            item={item}
            id={'e4-laderboard'}
            help={null}
            hideConfig
            extra={item.extra}
            loading={loading}
        />
    );
};

export default Leaderboard;
